<template>
  <div>
    <span class="call-duration">
      {{
        `${timerCount.hour > 0 ? plz(timerCount.hour) + ":" : ""}${
          timerCount.mins > 0 ? plz(timerCount.mins) + ":" : "00:"
        }${timerCount.secs > 0 ? plz(timerCount.secs) : "00"}`
      }}
  
    </span>
    <span
      v-show="
        !videoChatState.remoteMedia.audio || !videoChatState.remoteMedia.video
      "
      class="call-remote-media"
    >
      <i v-if="!videoChatState.remoteMedia.audio" class="material-icons">
        mic_off
      </i>
      <i v-if="!videoChatState.remoteMedia.video" class="material-icons">
        videocam_off
      </i>
    </span>
    <span v-if="timerCount.mins >= 9" class="call-duration" style="margin-top:40px; color: white; font-size: medium">Cet appel prendra fin dans moins d'une minute...</span>
  </div>
</template>

<script>
import { customLogger } from "@/utils";
export default {
  name: "RemoteMediaState",
  data() {
    return {
      timerCount: {
        hour: 0,
        mins: 0,
        secs: 0,
      },
    };
  },
  computed: {
    videoChatState() {
      const data = this.$store.state.videoChat;
      return data;
    },
  },
  created() {
    this.countUp();
  },
  methods: {
    plz(digit) {
      var zpad = digit + "";
      if (digit < 10) {
        zpad = "0" + zpad;
      }
      return zpad;
    },
    countUp() {
      setTimeout(() => {
        var hour, mins, secs;

        hour = this.timerCount.hour;
        mins = this.timerCount.mins;
        secs = this.timerCount.secs;
        secs++;
        if (secs == 60) {
          secs = 0;
          mins = mins + 1;
        }
        if (mins == 60) {
          mins = 0;
          hour = hour + 1;
        }
        if (hour == 13) {
          hour = 1;
        }

        this.timerCount = {
          hour,
          mins,
          secs,
        };
        this.countUp();
      }, 1000);
    },
    end_call() {
      this.$store
        .dispatch("EndCall")
        .then(() => {
          customLogger("end the call");
        })
        .catch((err) => {
          customLogger(err);
        });
    },
  },
};
</script>
